// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as jsxRuntime from "react/jsx-runtime";
import { AnimatedResourceValue } from "./AnimatedResourceValue.jsx";
export const j_ = "_resources_9wbum_1";
export const x_ = {
  resources: j_
};
export function ResourceSummaryStrip({
  metacoins: u,
  resources: o,
  className: m
}) {
  const r = [{
    label: "MetaCoin",
    value: u,
    icon: "/assets/resource-emojis/coin.webp"
  }, {
    label: "Value",
    value: o.crystals,
    icon: "/assets/resource-emojis/crystal.webp"
  }, {
    label: "Spins",
    value: o.spins,
    icon: "/assets/resource-emojis/card.webp"
  }, {
    label: "Gems",
    value: o.gems,
    icon: "/assets/resource-emojis/ruby.webp"
  }];
  return jsxRuntime.jsx("div", {
    className: [x_.resources, m].filter(Boolean).join(" "),
    children: r.map(({
      label: g,
      value: j,
      icon: B
    }) => jsxRuntime.jsxs("article", {
      "aria-label": `${g}: ${j.toLocaleString("ru-RU")}`,
      title: `${g}: ${j.toLocaleString("ru-RU")}`,
      children: [jsxRuntime.jsx("i", {
        children: jsxRuntime.jsx("img", {
          src: B,
          alt: "",
          "aria-hidden": true,
          width: 16,
          height: 16,
          style: { display: "block", width: 16, height: 16, objectFit: "contain" }
        })
      }), jsxRuntime.jsx("b", {
        children: jsxRuntime.jsx(AnimatedResourceValue, {
          value: j
        })
      })]
    }, g))
  });
}
